interface FormatMonthlyPriceOptions {
  nullFallback?: string
}

/**
 * Formats a price + currency into a renter-friendly monthly string.
 * Currency-aware enough for CAD/USD; defaults to '$' for unknown
 * values. Caller picks the null-case copy via `nullFallback`.
 *
 * @param {number | null} priceMonthly - the price; null when unknown
 * @param {string} priceCurrency - the currency code (CAD, USD, ...)
 * @param {FormatMonthlyPriceOptions} options - optional overrides
 * @returns {string} the formatted price string
 */
const formatMonthlyPrice = (
  priceMonthly: number | null,
  priceCurrency: string,
  options: FormatMonthlyPriceOptions = {},
): string => {
  if (priceMonthly === null) {
    return options.nullFallback ?? 'Price unknown'
  }

  const symbol = priceCurrency === 'USD' ? 'US$' : '$'
  return `${symbol}${priceMonthly.toLocaleString('en-CA')}/mo`
}

export { formatMonthlyPrice, type FormatMonthlyPriceOptions }
